import React from "react";

const JumboThemeFooterContext = React.createContext({});

export default JumboThemeFooterContext;